import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PageService, PdfExportService, SortService } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import {map} from 'rxjs';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { MysqlService } from './../../../services/mysql.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import {Brand} from './../../../shared/models/brand.model';
import { Job } from '../../../shared/models/job.model';
import { JobSubject } from '../../../shared/models/jobSubject.model';
import { SearchSubject } from '../../../shared/models/searchSubject.model';
import {SearchContact} from '../../../shared/models/searchContact.model';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';

@Component({
  selector: 'app-new-system-contacts-report',
  templateUrl: './new-system-contacts-report.component.html',
  styleUrls: ['./new-system-contacts-report.component.css'],
  providers: [ToolbarService, ExcelExportService, ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class NewSystemContactsReportComponent implements OnInit {


  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('agent_grid') public agent_grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  job_table3: any;
  brand_types: any;
  btLocalRecord: any;
  users: any;
  userLocalRecord: any;
  userPrimaryLocalRecord: any;
  usersPrimary: any;
  job_table_clients: any;
  job_table_clents3: any;
  job_table_clients3: any;
  job_table_agents: any;
  job_table_agents3: any;
  subjects_urgent1: Object;
  subjects_urgent_user: any;
  subjects_results: any;


  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'surname', value: 'user_id' };
  DialogObj: any;

  
  today = new Date();
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  search_results: any;
  new_results: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: Date;
  valueDatePickerDate2: Date;
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  subjects_urgent_agent: any;
  search_model: SearchContact;
  contact_search: Object;
  contact_search_results: any;
  brand_search: Object;
  brand_search_results: any;
  user_search: Object;
  user_search_results: any;

  brand_user_join_results: any = [];
  user_levels: Object;
  brand_user_join_results_agent: any[];

  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  brand_search_results_agent: any;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
  ) { 

       // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
         //   this.toastr.setRootViewContainerRef(vcr);
      // Date picker date format
       //  this.valueDatePickerDate = new Date(this.today);
         this.valueDatePickerDate = this.removeDays(90);


  }

  ngOnInit() {

    this.search_model = new SearchContact();
    this.getFormUserLevels();
    this.getBrandBrandTypes();

    // this.mapJobTableLive(); // load the table data
    // this.mapJobTableLiveClients();
    // this.mapJobTableLiveAgents();
    
    this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy' };

  }
  



// New way of rendering table data
mapJobTableLive() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;

  this.job_table2.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table3;
})
 ) // end pipe
  .subscribe(results => this.job_table3 = results
  );

}






// New way of rendering table data
mapJobTableLiveClients() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands/clients')
 .pipe(map(data => {
  // do your transformations
  this.job_table_clients = data;

  this.job_table_clients.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table_clients3;
})
 ) // pipe
  .subscribe(results => this.job_table_clients3 = results
  );

}



// New way of rendering table data
mapJobTableLiveAgents() {

  this.getBrandBrandTypes();
  this.getUsers();
  

  this.http.get<any>(this.gfunc.apiURL + '/api/brands/agents')
 .pipe(map(data => {
  // do your transformations
  this.job_table_agents = data;

  this.job_table_agents.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
this.changeObject = Object.assign(this.btLocalRecord);
  element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table_agents3;
})
 )// end poipe
  .subscribe(results => this.job_table_agents3 = results
  );

}







toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.mapJobTableLive();
  this.grid.refresh();
};




getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      this.usersPrimary = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


brandView(brand_id) {
  this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
}

brandEdit(brand_id) {
  this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
}


userView(user_id) {
  this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
}

userEdit(user_id) {
  this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
}




// :: Reporting
getReportContactsSearch(search_model) {

  search_model.brand_type_id = null;
  search_model.assigned_agent = null;
  this._demoService.getReportContactsSearch(search_model).subscribe(
    data => { this.contact_search = data;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.contact_search_results = DataUtil.parse.parseJson(data); 
   //   this.subjects_results = DataUtil.parse.parseJson(data); 
     // console.log("Done loadng USER");
    //  console.log(data);

   //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
     this.grid.refresh();
   
     // :: This section allow to hard code predicate filters before loading data in to DataManager

      // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
      // predicate = predicate.or('subject_id', 'equal', 303);
      // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));

    },
    error => {
    console.error('Error Loading !' + error.error);
    console.log(error);
    //return Observable.throw(error);
    }
  ); }



  
// :: Reporting
getReportBrandsClientSearch(search_model) {
this.brand_user_join_results = [];
search_model.brand_type_id = 2;
search_model.access_level = 9;
  this._demoService.getReportBrandsSearch(search_model).subscribe(
    data => { this.brand_search = data;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.brand_search_results = DataUtil.parse.parseJson(data); 
// get the users as well and join the records together
this.getReportUsersSearch(search_model);

// now how to join two arrays of objects.
// maybe pass results in to a new model.

// Count items of brand search to loop through
let  count_of_brand_items = Object.keys(this.brand_search).length;
// now loop and push to join model
for(let i=0;i < count_of_brand_items; i++) {
  let res = this.brand_search_results[i];

    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
    this.brand_user_join_results.push({
      email_address: res.email,
      first_name: res.name,
      surname: res.surname,
      company_name: res.name,
      created: res.created,
            });

} // end brands loop.

this.brand_user_join_results = this.brand_user_join_results;

     this.grid.refresh();
    },
    error => {
    console.error('Error Loading !' + error.error);
    console.log(error);
    // return Observable.throw(error);
    }



    
  ); }



  

  getReportBrandsAgentSearch(search_model) {
    this.brand_user_join_results_agent = [];
    search_model.brand_type_id = 3;
    search_model.access_level = 5;
    
    
      // search_model.brand_report_id = null;
      // search_model.assigned_agent = null;
      this._demoService.getReportBrandsSearch(search_model).subscribe(
        data => { this.brand_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.brand_search_results_agent = DataUtil.parse.parseJson(data); 
    // get the users as well and join the records together
   
    this.getReportUsersSearch(search_model);
    
    // now how to join two arrays of objects.
    // maybe pass results in to a new model.
    
    // Count items of brand search to loop through
    let  count_of_brand_items = Object.keys(this.brand_search_results_agent).length;
    // now loop and push to join model
    for(let i=0;i < count_of_brand_items; i++) {
      let res = this.brand_search_results_agent[i];
    
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        this.brand_user_join_results_agent.push({
          email_address: res.email,
          first_name: res.name,
          surname: res.surname,
          company_name: res.name,
          created: res.created,
                });
    
    } // end brands loop.
    
 //  this.brand_user_join_results_agent = this.brand_user_join_results_agent;
 this.brand_user_join_results_agent =  DataUtil.parse.parseJson(this.brand_user_join_results_agent);
    this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         

          }
    



  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }


   getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

  getReportUsersSearch(search_model) {

    this._demoService.getReportUsersSearch(search_model).subscribe(
      data => { this.user_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.user_search_results = DataUtil.parse.parseJson(data);
// Count items of users search to loop through
let  count_of_user_items = Object.keys(this.user_search).length;
// now loop and push to join model
for(let i=0;i < count_of_user_items; i++) {
  let res = this.user_search_results[i];


    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
    this.brand_user_join_results.push({
      email_address: res.email_address,
      first_name: res.first_name,
      surname: res.surname,
      company_name: res.company_name,
      created_date: res.created_date,
            });


} // end users loop.

this.brand_user_join_results = this.brand_user_join_results;
this.grid.refresh();


    //   this.grid.refresh();
     //  this.agent_grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
    ); }



addDays(days : number): Date{
let futureDate = new Date();
futureDate.setDate(futureDate.getDate() + days);
return futureDate;
}


removeDays(days : number): Date{
let futureDate = new Date();
futureDate.setDate(futureDate.getDate() - days);
return futureDate;
}

/// TABS
selectTab(tab_id: number) {
this.staticTabs.tabs[tab_id].active = true;
this.brand_user_join_results = null; // refresh the model when a tab is clicked.?
};








  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

    //  this.grid.showSpinner();

    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   


    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.brand_user_join_results }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
      this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que"); 
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }

   //  this.grid.hideSpinner();

}


exportPDFClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
      this.grid.pdfExport();
  }
}



}
